import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { ProductFormContext } from 'context';
import type { ComponentMode, Product as ProductConfig } from 'types';

import { ProductForm, ProductHeader } from './components';

type ProductProps = {
  mode: ComponentMode;
};

export default function Product({ mode }: ProductProps) {
  const data = useLoaderData() as ProductConfig | undefined;

  const { name, status } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const step = 1;
  const title = isUpdatedMode ? name : 'افزودن محصول جدید';
  const defaultName = isUpdatedMode ? name : '';
  const defaultStatus: typeof status = isUpdatedMode ? status : 'Draft';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <ProductHeader>{title}</ProductHeader>
      <ProductFormContext
        mode={mode}
        step={step}
        defaultName={defaultName}
        defaultStatus={defaultStatus}
        ownerType='Product'
        {...(isUpdatedMode ? data : {})}
      >
        <ProductForm />
      </ProductFormContext>
    </React.Fragment>
  );
}
